module.exports = __webpack_public_path__ + "static/media/Pet Cover.a409fa80.png";